import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { NetworkContext } from '../context/NetworkContext';
import { SYNC_STATUS } from '../context/types/NetworkTypes';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Settings, LockKeyhole, RefreshCw } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, checkUnlock, checkUnlockPincode } from '../store';
import CustomText from '../styles/CustomText';

import useSecureStorage from '../hooks/useSecureStorage';
import { shortWalletAddress } from '../utils/utils';

import { tgShowConfirm } from '../utils/telegramPopup';

import { Select } from 'antd';
import i18next from 'i18next';
import { DefaultTokenContext } from '../context/DefaultTokenContext';

const MainPageHeader: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const { Option } = Select;
	const networkContext = useContext(NetworkContext);

	const { 
		syncStatus, 
		countSyncProcess, 
		countSyncComplete,
		startDbSyncTimer
	} = useContext(NetworkContext)

	let navigate = useNavigate();
	const { t } = useTranslation();
	let headerText = useSelector((state: RootState) => state.headerText);
	let dispatch = useDispatch();
	
	const [ walletAddress, setWalletAddress ] = useState('')
	const [ walletName, setWalletName ] = useState('')
	const [ refreshing, setRefreshing ] = useState(false)
	const [ selectedNetwork, setSelectedNetwork ] = useState<string>('');
	const [ defaultNetwork, setDefaultNetwork ] = useState<any[]>([]);

	const { 
		searchNetwork,
		getNetworkInfo
	} = useContext(DefaultTokenContext);

	const { 
		getWalletAddress, 
		getBlockChain,
		setBlockChain,
		setNetworkCurrency,
		overwriteWalletData,
		checkSavedNetworkWalletData
	} = useSecureStorage()

	let isChangeNetworkStart = false // 네트워크 변경 요청 실행중

	useEffect(() => {
		const fetchWalletAddress = async () => {
			const address = await getWalletAddress()
			const walletAddress = await shortWalletAddress(address)
			setWalletAddress(walletAddress)

			// 현재 블록체인의 아이콘 정보
			const networkName = await getBlockChain()
			console.log(`MainPageHeader fetchWalletAddress networkName`, networkName)
			setSelectedNetwork(networkName);

			// QSS에 지갑주소가 있으면 QSS의 지갑주소 표시
			// QSS에 지갑주소 없으면 기본 이름 표시
			const walletName = `${networkName} Wallet`
			setWalletName(walletName);
		}

		const fetchDefaultNetwork = async () => {
			const networks = await getNetworkInfo('')
			setDefaultNetwork(networks)
		}

		fetchWalletAddress()
		fetchDefaultNetwork()
	}, [])

	useEffect(() => {
		const syncLoading = async () => {
			if(syncStatus === SYNC_STATUS.CHECKING ||syncStatus === SYNC_STATUS.PROCESSING) {
				setRefreshing(true)
			} else {
				setRefreshing(false)
			}
		}

		syncLoading()

	}, [syncStatus])

	/**
	 * 네트워크 선택
	 * @param network 
	 */
	const handleSelectNetwork = async (
		networkSymbol: string) => {
		try {
			const checkSavedNetwork = await checkSavedNetworkWalletData(networkSymbol.toLowerCase())
			console.log(`handleSelectNetwork checkSavedNetwork`, checkSavedNetwork)

			// 지갑정보가 생성-저장된 네트워크인지 확인
			if(false === checkSavedNetwork) {
				// await tgShowAlert(t('balance_screen_message_19'));
				await alert(t('balance_screen_message_19'))
				// await new Promise(resolve => setTimeout(resolve, 800)); // 1초 딜레이 추가
				return;
			}

			console.log(`handleSelectNetwork 시작 상태 : `, isChangeNetworkStart)
			if(true === isChangeNetworkStart) {
				console.log(`handleSelectNetwork 변경이 진행 중. ${networkSymbol} 로 변경 중지`)
				// await tgShowAlert(t('balance_screen_message_16'));
				await alert(t('balance_screen_message_16'))
				return
			}
			
			// 네트워크 변경 시작 상태 설정
			isChangeNetworkStart = true;
	
			// 변경하려는 네트워크 정보 
			console.log(`handleSelectNetwork network 변경 시작. 변경할 network : `, networkSymbol.toLowerCase())
	
			const isConfirm = await tgShowConfirm(t('balance_screen_message_15'));
			await new Promise(resolve => setTimeout(resolve, 800)); // 1초 딜레이 추가
			
			if(true === isConfirm) {
				// defaultToken context 에서 네크워크 정보 검색
				const newNetworkInfo = await searchNetwork(networkSymbol)
				console.log(`handleSelectNetwork netNetworkInfo`, newNetworkInfo)
				if (newNetworkInfo === null || newNetworkInfo.symbol === '') {
					isChangeNetworkStart = false;
					// await tgShowAlert(t('balance_screen_message_17'));
					await alert(t('balance_screen_message_17'))
					// await new Promise(resolve => setTimeout(resolve, 800)); // 1초 딜레이 추가
					return;
				}
	
				// 현재 활성화된 네트워크 정보를 선택한 네트워크 정보로 덮어씌우기
				const overwriteResult = await overwriteWalletData(newNetworkInfo.symbol.toLowerCase())
				console.log(`handleSelectNetwork overwriteResult`, overwriteResult)
				if(false === overwriteResult) {
					console.log(`handleSelectNetwork overwriteResult Fail Popup`)
					isChangeNetworkStart = false;
					// await tgShowAlert(t('balance_screen_message_18'));
					await alert(t('balance_screen_message_18'))
					// await new Promise(resolve => setTimeout(resolve, 800)); // 1초 딜레이 추가
					return;
				}
	
				// 선택한 네트워크와 저장
				await setBlockChain(newNetworkInfo.symbol.toLowerCase())
	
				// 선택한 network currency 저장
				await setNetworkCurrency(newNetworkInfo.currency.toLowerCase())
	
				// 현재 선택 네트워크 저장
				await setSelectedNetwork(newNetworkInfo.symbol)
	
				// NetworkContext의 setSelectedNetwork 호출해서 교체
				await networkContext.setSelectedNetwork(newNetworkInfo.symbol.toLowerCase());
				
				// 언락 페이지로 이동
				moveUnLockPage()
			}
		} catch (error) {
			console.error(`Error handleSelectNetwork : `, error)
		} finally {
			// 네트워크 변경 시작 상태 설정
			isChangeNetworkStart = false;
			console.log(`handleSelectNetwork finally: `, isChangeNetworkStart)
		}
	}

	const handleLock = () => {
		console.log(`UnlockScreen handlePinCodeintAuthSuccess`)
		
		// 언락 상태 변경
		dispatch(checkUnlock(false))

		// unlockPincode 삭제
		dispatch(checkUnlockPincode(''))

		setTimeout(() => {
            // 잠금해제 페이지로 이동
            navigate(`/UnlockScreen`)
        }, 500)
	}

	const handleDbTxSyncStart = async () => {
		// DB TX 현행화 타이머 시작
		await startDbSyncTimer()
	}

	/**
	 * 언락 페이지로 이동
	 */
	const moveUnLockPage = () => {
		console.log(`MainPageHeader moveUnLockPage`)
		
		// 언락 상태 변경
		dispatch(checkUnlock(false))

		// unlockPincode 삭제
		dispatch(checkUnlockPincode(''))

		setTimeout(() => {
            // 잠금해제 페이지로 이동
            navigate(`/UnlockScreen`, { replace: true, state: { } });
        }, 100)
	}

	const styles = {
		container: {
			width: "calc(100% - 48px)",
			height: "30px",
			padding: "12px 24px",
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			top: "0",
			left: "0",
			right: "0",
			maxWidth: "450px",
			margin: '0 auto',
			background: theme.background_03,
			position: "fixed",
			zIndex: 100,
		} as React.CSSProperties,
		leftContainer: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-start",
			gap: "10px",
		} as React.CSSProperties,
		networkSelectContainer: {
			display: "flex",
			width: "66",
			borderRadius: 10,
			justifyContent: 'left',
			alignItems: 'center',
		} as React.CSSProperties,
		iconBox: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			gap: 20,
		} as React.CSSProperties,
		icon: {
			width: "22px",
			height: "22px",
			cursor: "pointer",
		} as React.CSSProperties,
		text: {
			color: theme.text_01,
			fontSize: "18px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		} as React.CSSProperties,
		walletInfo: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			justifyContent: "center",
			gap: "4px",
			color: theme.text_02,
			fontSize: "14px",
		} as React.CSSProperties,
		walletName: {
			fontWeight: "bold",
			fontSize: "16px",
			color: theme.text_01,
		} as React.CSSProperties,
		walletAddress: {
			fontSize: "12px",
			color: theme.text_02,
		} as React.CSSProperties,
		syncInfo: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			justifyContent: "center",
			gap: "4px",
			color: theme.text_02,
			fontSize: "12px",
		} as React.CSSProperties,
		syncText: {
			color: theme.text_01,
			fontSize: "16px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		} as React.CSSProperties,
		chainIconContainer: {
			width: 35,
			height: 35,
			borderRadius: 25,
			backgroundColor: theme.img_background_01,
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			marginRight: 15
		} as React.CSSProperties,
		chainIcon: {
			width: 38,
			height: 38
		} as React.CSSProperties,
	};
	
	return (
	<div style={{ ...styles.container, backgroundColor: theme.background_normal }}>
		{/* 왼쪽 정렬 컨테이너: 네트워크 셀렉트 + 헤더 텍스트 */}
		<div style={styles.leftContainer}>
			<div style={styles.networkSelectContainer}>
				<Select
					className="custom-select"
					value={selectedNetwork.toUpperCase()}
					onChange={(value) => {handleSelectNetwork(value);}}
					style={{ width: 55 }}
					popupMatchSelectWidth={false}
					dropdownStyle={{ width: 120 }}
					optionLabelProp="icon" // 기본 표시 영역에 label 속성만 렌더링
				>
					{defaultNetwork.map((network) => (
						1 == network.is_active && (
							<Option 
								key={network.symbol}
								value={network.symbol.toUpperCase()} 
								icon={<img src={network.icon} style={{ width: 24, height: 24, paddingTop: 10 }} alt={network.symbol} />}
							>
								<div style={{display:'flex', alignItems:"center"}}>
									<img src={network.icon} style={{width: 24, height: 24, paddingRight: 5}}/>{network.symbol.toUpperCase()}
								</div>
							</Option>
							)
					))}
				</Select>
			</div>
			<div style={{ color: "white", display: "flex", alignItems: "left", gap: "0px", marginLeft: "0px" }}>
				<CustomText style={{ ...styles.text }}>{headerText.title}</CustomText>
			</div>
		</div>

		{/* 오른쪽 정렬 컨테이너: 동기화 정보 + 잠금 + 설정 */}
        <div style={{ ...styles.iconBox }}>
			<div style={styles.syncInfo}>

				{syncStatus === SYNC_STATUS.CHECKING && (
					<></>
				)}
				{syncStatus === SYNC_STATUS.PROCESSING && (
					<CustomText style={{ ...styles.syncText }}>
						{countSyncProcess}/{countSyncComplete}
					</CustomText>
				)}
				{syncStatus === SYNC_STATUS.STOP && (
					<CustomText style={{ ...styles.syncText }}>
						{i18next.t('sync_db_tx_message_03')}
					</CustomText>
				)}
				{syncStatus === SYNC_STATUS.COMPLETE && (
					<></>
				)}
				{syncStatus === SYNC_STATUS.ERROR && (
					<CustomText style={{ ...styles.syncText }}>
						{i18next.t('sync_db_tx_message_05')}
					</CustomText>
				)}
				{syncStatus === SYNC_STATUS.SYNCKEY_ERROR && (
					<CustomText style={{ ...styles.syncText }}>
						{i18next.t('sync_db_tx_message_06')}
					</CustomText>
				)}
			</div>
			<div style={{ ...styles.icon }} onClick={() => {handleDbTxSyncStart()}}>
				<RefreshCw
					color={theme.text_01}
					size={22}
					className={refreshing ? 'rotating-icon-repeat' : ''}
				/>
            </div>
			<div style={{ ...styles.icon }} onClick={() => handleLock()}>
                <LockKeyhole size={22} color={theme.text_01} />
            </div>
            <div style={{ ...styles.icon }} onClick={() => navigate(`/SeeMoreScreen`)}>
                <Settings size={22} color={theme.text_01} />
            </div>
        </div>
    </div>
	)
}

export default MainPageHeader
